export default __webpack_public_path__ + "static/APP_4_3-7961510e4f72e1875f77c836a033938a.png";